import React from 'react';
import {colors as themecolors} from '@/theme';

interface RadialGradientBallProps {
  radius?: number;
  colors?: string[];
  className?: string;
}

export const RadialGradientBall: React.FC<RadialGradientBallProps> = props => {
  const {
    radius = 50,
    className,
    colors = [
      themecolors.palette.ui_blue,
      themecolors.palette.ui_blue_background,
    ],
  } = props;
  const gradientColors = colors.toReversed().join(', ')
  // On web, use CSS radial-gradient
  return (
    <div
      className={className}
      style={{
        width: radius * 2,
        height: radius * 2,
        borderRadius: radius,
        background: `radial-gradient(circle, ${gradientColors})`,
      }}
    />
  );
};